import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderOpen: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="folder-open"><path d="M8 10.75L5.5 19.25H19.5L22 10.75H20.25H8Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><path d="M5.5 19.25H2.75V3.75H10L12 6.75H20.25V10.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
};

export default IconFolderOpen;
